import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, ParamMap} from "@angular/router";
import {switchMap, timeout} from 'rxjs/operators';
import {ExternalApiGatewayService} from "../../../services/external-api-gateway.service";
import {ToastService} from "../../../services/toast-service";
import {SharedService} from "../../../services/sharedService";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { HttpClient } from "@angular/common/http";

@Component({
    selector: 'app-external-api-gateway-edit',
    templateUrl: './external-api-gateway-edit.component.html',
    standalone: false
})
export class ExternalApiGatewayEditComponent implements OnInit, AfterViewInit {

    // extApi: any = {};
    submitted = false;


    form: FormGroup;
    submitting = false;
    submitSuccess = false;
    submitError = '';

    // Test button state per URL field
    testLabels: Record<string, string> = { url: 'Test', sampleUrl: 'Test' };
    testStates: Record<string, string> = { url: 'btn btn-outline-secondary', sampleUrl: 'btn btn-outline-secondary' };
    testLoading: Record<string, boolean> = { url: false, sampleUrl: false };

    constructor(public extApiService: ExternalApiGatewayService,
                private router: Router,
                private route: ActivatedRoute,
                private alertService: ToastService,
                private sharedService: SharedService,
                private fb: FormBuilder,
                private http: HttpClient) {
        this.form = this.fb.group({
            id:         [null],
            name:       ['', Validators.required],
            url:        ['', [Validators.required, Validators.pattern('https?://.+')]],
            sampleUrl:  ['', [Validators.required, Validators.pattern('https?://.+')]],
            itemsPath:  [null],
            totalPath:  [null],
            method:     ['', Validators.required],
            isActive:   [true]
        });
    }

    ngAfterViewInit(): void {
        this.sharedService.loadMenuItems('admin');
    }

    isInvalid(field: string): boolean {
        const control = this.form.get(field);
        return !!(control && control.invalid && (control.dirty || control.touched));
    }
    //
    // onSubmit() {
    //     this.submitted = true;
    //     this.extApiService.upsert$(this.extApi)
    //         .subscribe(service => {
    //             this.alertService.show('External API saved successfully.')
    //             setTimeout(() => this.goToList(), 1000)
    //             this.goToList()
    //         });
    // }

    goToList() {
        this.router.navigateByUrl('/ext-api');
    }

    ngOnInit(): void {
        // this.extApi = {};
        this.route.paramMap.pipe(
            switchMap((params: ParamMap) => this.extApiService.get$(params.get('id'))))
            .subscribe(extApiEntity => {
                if (extApiEntity) {
                    // this.extApi = extApiEntity;
                    this.form.patchValue(extApiEntity)
                }
            });
    }

    testUrl(field: string): void {
        const url = this.form.get(field)?.value?.trim();

        if (!url) {
            this.setTestState(field, 'No URL', 'fail');
            setTimeout(() => this.resetTestBtn(field), 2000);
            return;
        }

        this.testLoading[field] = true;
        this.setTestState(field, 'Testing…', 'testing');

        this.http.get(url, { observe: 'response' }).pipe(
            timeout(10000)
        ).subscribe({
            next: (res) => {
                let isArray;
                const itemsPath = this.form.get('itemsPath')?.value?.trim()
                if (itemsPath){
                    isArray = Array.isArray(res.body[itemsPath]);
                }else{
                    isArray = Array.isArray(res.body);
                }
                this.setTestState(field, isArray ? 'JSON array ✓' : 'Not an array', isArray ? 'ok' : 'fail');
                this.testLoading[field] = false;
                setTimeout(() => this.resetTestBtn(field), 3000);
            },
            error: (err) => {
                const label = err?.name === 'TimeoutError' ? 'Timed out' :
                    err?.status === 0            ? 'CORS blocked' :
                        `Error ${err?.status ?? ''}`.trim();
                this.setTestState(field, label, 'fail');
                this.testLoading[field] = false;
                setTimeout(() => this.resetTestBtn(field), 3000);
            }
        });
    }

    private setTestState(field: string, label: string, state: 'ok' | 'fail' | 'testing' | 'default'): void {
        this.testLabels[field] = label;
        const stateClass = state === 'default' ? '' : ` btn-test-${state}`;
        this.testStates[field] = `btn btn-outline-secondary${stateClass}`;
    }

    private resetTestBtn(field: string): void {
        this.setTestState(field, 'Test', 'default');
    }

    onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        this.submitting = true;
        this.submitSuccess = false;
        this.submitError = '';

        const payload = this.form.value;
        // console.log('Submitting:', payload);

        setTimeout(() => {
            this.submitting = false;
            this.submitSuccess = true;

            this.submitted = true;
            this.extApiService.upsert$(payload)
                .subscribe(service => {
                    this.alertService.show('External API saved successfully.')
                    setTimeout(() => this.goToList(), 1000)
                    this.goToList()
                });


        }, 1000);
    }


}
